import { createReduxAsyncThunk } from 'shared/utils';

import { driversAPI } from '../../api';

import { DRIVERS_STATE } from '../../constants';

import { AddDriverFuelAssignmentForm } from '../../types';

export const addDriverFuelAssignment = createReduxAsyncThunk(
  `${DRIVERS_STATE}/addDriverFuelAssignment`,
  async (form: AddDriverFuelAssignmentForm) => {
    const { data } =await driversAPI.addDriverFuelAssignment(form);
    return data;
  }
);
